import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {

  address: null,
  user: {
    firstName: null,
    lastName: null,
    rewardPoints: null,
    rewardAmount: null,
  },
  transactions: [],
  redeemed: [],

};

const getters = {
  getUser (state) {
    return state.user;
  },

  getAddress (state) {
    return state.address;
  },
  getTransactions (state) {
    return state.transactions;
  },
  getRedeemed (state) {
    return state.redeemed;
  },

};

const mutations = {

  setUser (state, payload) {
    state.user = payload;
  },
  setAddress (state, payload) {
    state.address = payload;
  },
  setTransactions (state, payload) {
    state.transactions = payload;
  },
  setRedeemed (state, payload) {
    state.redeemed = payload;
  },

};

const actions = {

  fetchUser ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user')
        .then(res => {
          commit('setUser', res.data.data)
          console.log('fetchUser - fetchUser.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchAddress ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/address')
          .then(res => {
            commit('setAddress', res.data.data)
            console.log('fetchAddress - fetchUser.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  fetchTransactions ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/transaction')
          .then(res => {
            commit('setTransactions', res.data.data)
            console.log('fetchTransactions - fetchUser.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },


  fetchRedeemed ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/redeem')
          .then(res => {
            commit('setRedeemed', res.data.data)
            console.log('fetchRedeemed - fetchUser.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },


};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/user.js